"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ASTERISKS = exports.MASKED_PHONE_REGEX = exports.MASKED_EMAIL_SPECIAL_CASE_REGEX = exports.MASKED_EMAIL_REGEX = exports.PASSWORD_RULES = exports.USERNAME_RULES = exports.CATEGORIZED_STATEMENT_TYPES = exports.ID_NUMBER_REGX = void 0;
const enum_1 = require("./enum");
exports.ID_NUMBER_REGX = {
    nric: /^[0-9]{12}$/,
    arid: /^[a-zA-Z0-9]{12}$/,
    oldIc: /^[a-zA-Z0-9]{7,12}$/,
    passport: /^[a-zA-Z0-9]{1,20}$/i,
};
exports.CATEGORIZED_STATEMENT_TYPES = {
    [enum_1.StatementTypeCategory.UT]: Object.values(enum_1.StatementUt),
    [enum_1.StatementTypeCategory.PRS]: Object.values(enum_1.StatementPrs),
};
/**
 * @see https://principalseasia.atlassian.net/browse/BW20R-54
 */
exports.USERNAME_RULES = {
    length: /^.{8,20}$/,
    symbol: /^(^[a-z\d]+)$/,
    any_numeric: /[\d]+/,
};
/**
 * @see https://principalseasia.atlassian.net/browse/BW20R-55
 */
exports.PASSWORD_RULES = {
    length: /^.{8,12}$/,
    symbol: /^[\w\d-.$@!_#%&^*()/|\\?<>]+$/,
    any_uppercase: /[A-Z]+/,
    any_numeric: /[\d]+/,
};
exports.MASKED_EMAIL_REGEX = /(?<=..).*(?=[^@]*@)/m;
exports.MASKED_EMAIL_SPECIAL_CASE_REGEX = /(?<=.).*(?=[^@]*@)/m;
exports.MASKED_PHONE_REGEX = /(?<=\d{2})\d+(?=\d{2})/g;
exports.ASTERISKS = '***';
